import styled, { css } from 'styled-components';
import {FP_VOUCHER_TYPES} from "../../../../common/const/free_play_consts";



export const GameItemContainerBox = styled.div<{freePlayType?: FP_VOUCHER_TYPES; hide?: boolean;}>`
    // cgp-game-item-container
    display: ${({hide}) => hide ? "none" : "flex"};
    ${({freePlayType, theme}) => freePlayType ? css`
        width: 35.5rem;
    ` : ""}

    /* When inside .cgp-free-play-games-list-component.cgp-fp-games-disabled apply {cursor: auto; z-index: -1;} // see games.scss in free_play */
    .cgp-free-play-games-list-component.cgp-fp-games-disabled & {
        cursor: auto;
        z-index: -1;
    }

    /* When also have cgp-game-item-fp class but is inside .idleRecommendation-layout apply width: 100% */
    .idleRecommendation-layout &.cgp-game-item-fp {
        width: 100%;
    }
`;